<template lang="html">
  <div class="vacuo">
    <img class="vacuoImg" src="@/assets/image/activity/vacuo/vacuo.jpg">
    <div class="footerMod" @click="getAttendMeetings">
      <p>我要参会</p>
    </div>
  </div>
</template>

<script>
	import { pagebase } from '@/utils/http.js';
	import WxShare from '@/utils/wxshare';

  export default {
    data() {
			return {
				pagebase: pagebase,
			}
		},
    mounted() {
      window.scroll(0, 0);
      this.init();
    },

    methods: {
      init(){
				this.wxshare = new WxShare();
				this.wxshare.share({
					title: '第七届中国真空行业年会暨真空技术创新交流活动',
					desc: '诚挚邀请您参加，于今年3月14日-16日在深圳举办“创新驱动，共筑真空未来”中国真空行业年会暨真空技术创新交流活动',
					link: window.location.href,
					imgUrl: pagebase + '/static/img/vacuo.jpg',
				})
			},

      getAttendMeetings() {
        window.location.href = 'http://eda365520.mikecrm.com/1pI8lwq';
      }
    }
  }
</script>

<style lang="css" scoped>
  .vacuo {
    width: 100%;
    background-color: #062478;
  }

  .vacuoImg {
    width: 100%;
    object-fit: cover;
  }

  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .footerMod p {
    width: 15rem;
    padding: 1rem  0;
    border-radius: 4rem;
    background-color: red;
    color: #FFF;
    font-size: 1.8rem;
  }
</style>